import request from '../config/axios-config';

export function getDelegatedUser() {
    return (
        request({
            method: 'get',
            url: '/flow/delegate'
        }))
}

export function deleteDelegatedUser() {
    return (
        request({
            method: 'post',
            url: '/flow/delete/delegate'
        }))
}

export function saveDelegate(userId) {
    return (
        request({
            method: 'post',
            url: '/flow/add/delegate/' + userId
        }))
}